const consumerMapTable = {
  shoes: { en: 'shoes', th: 'รองเท้า' },
  bag: { en: 'bag', th: 'กระเป๋า' },
  accessories: { en: 'accessories', th: 'เครื่องตกแต่ง' },
  perfume: { en: 'perfume', th: 'น้ำหอม' },
  lifestyle: { en: 'lifestyle', th: 'สินค้าอุปโภคบริโภค' }
}

export default (type) => consumerMapTable[type.toLowerCase()] || { en: 'clothing', th: 'เครื่องแต่งกาย' }
